import { BaseRouteService } from 'core/services';

class ShipmentInfoReturnRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'shipment-info-return/';
	}

	find = filter => {
		return super.create(this.base + 'search', filter);
	};

	exportToCsv(filter) {
		return super.create(this.base + 'export', filter);
	}

	reprintLabel = (shipmentInfoReturnId, getLabel) => {
		return super.update(this.base + 'reprintReturnLabel/{shipmentInfoReturnId}/{?getLabel}', {
			shipmentInfoReturnId,
			getLabel,
		});
	};

	createReturnLabel = returnLabelParams => {
		return super.update(this.base + 'return-label', returnLabelParams);
	};
}

export default ShipmentInfoReturnRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/ShipmentInfoReturnRouteService.js